export default __webpack_public_path__ + "static/media/Brocolli.d7849c2e.jpg";